import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { AttributeTextValue, AttributeValueBase } from '@msdyn365-commerce/retail-proxy';

export const getAttributeByName = (attributes: AttributeValueBase[], name: string): AttributeValueBase | undefined => {
    if (!name || !ArrayExtensions.hasElements(attributes)) {
        return undefined;
    }

    const attribute = attributes?.find(x => x.Name?.toUpperCase() === name?.toUpperCase());

    return attribute;
};

export const getAttributeTextValueByName = (attributes: AttributeValueBase[], name: string): string => {
    let textValue = '';

    if (!name || !ArrayExtensions.hasElements(attributes)) {
        return textValue;
    }

    const attribute = getAttributeByName(attributes, name) as AttributeTextValue;
    if (attribute && attribute.TextValue) {
        textValue = attribute.TextValue;
    }

    return textValue;
};

export const addOrUpdateAttributeTextValue = (attributes: AttributeValueBase[], name: string, value: string): void => {
    if (attributes && name) {
        const attribute = getAttributeByName(attributes, name) as AttributeTextValue;
        if (attribute) {
            attribute.TextValue = value;
        } else {
            attributes.push(createTextAttribute(name, value));
        }
    }
};

export const createTextAttribute = (name: string, value: string) => {
    return {
        Name: name,
        TextValue: value,
        TextValueTranslations: [],
        '@odata.type': '#Microsoft.Dynamics.Commerce.Runtime.DataModel.AttributeTextValue'
    };
};
